import React from 'react'

function StatusTitle({ titleText }) {
  return (
    <h1 className="status-title">{ titleText }</h1>
  )
}

export default StatusTitle;